import React from 'react';
import { SEO } from './components/SEO';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { USPBar } from './components/USPBar';
import { Services } from './components/Services';
import { CorePrintBlock } from './components/CorePrintBlock';
import { Branches } from './components/Branches';
import { ClientCases } from './components/ClientCases';
import { Reviews } from './components/Reviews';
import { GuaranteeSection } from './components/GuaranteeSection';
import { Werkproces } from './components/Werkproces';
import { TeamCarousel } from './components/TeamCarousel';
import { BlogSection } from './components/BlogSection';
import { FAQ } from './components/FAQ';
import { ContactForm } from './components/ContactForm';
import { Footer } from './components/Footer';
import { localBusinessSchema, websiteSchema, buildFAQSchema } from './lib/structuredData';
import { homeFaqs } from './data/faq';
export function App() {
  return <div className="w-full min-h-screen bg-white text-[#111827] font-sans" data-id="element-0" data-mp="3ijxokogyjwiu">
      <SEO title="Online gevonden worden in Noord-Holland Noord | Noord Digital" description="Noord Digital zorgt dat ondernemers in Noord-Holland Noord online gevonden worden en professioneel overkomen. Websites, vormgeving, hosting, e-mail en SEO uit Oudkarspel." keywords="online gevonden worden, website laten maken Noord-Holland, huisstijl laten maken, vormgeving Dijk en Waard, seo Noord-Holland Noord, webdesign Oudkarspel, lokaal mkb marketing" canonical="https://noorddigital.nl/" jsonLd={[localBusinessSchema, websiteSchema, buildFAQSchema(homeFaqs)]} data-id="element-1" data-mp="3ihv048vgebg8" />
      <Header data-id="element-2" data-mp="38kqgafp2ys2l" />
      <Hero data-id="element-3" data-mp="38k6w0sbyjrle" />
      <USPBar data-id="element-4" data-mp="38nup5qdhqbzl" />
      <div id="services" className="scroll-mt-24" data-id="element-5" data-mp="38o4d78ez692n">
        <Services data-id="element-6" data-mp="3dlntsez5axxr" />
      </div>
      <CorePrintBlock data-id="element-7" data-mp="3dirtwl3qlz6o" />
      <Branches data-id="element-8" data-mp="nvj179a902mk" />
      {/* De id client-cases staat op de sectie binnen ClientCases zelf,
          samen met de scroll-offset. Hier geen tweede id plaatsen. */}
      <ClientCases data-id="element-9" data-mp="sssqmoxn0eae" />
      <Reviews data-id="element-10" data-mp="swgmhuqk1csa" />
      <GuaranteeSection data-id="element-11" data-mp="3684hdq2uasw" />
      <Werkproces data-id="element-12" data-mp="35ovwnmbgyrj" />
      <TeamCarousel data-id="element-13" data-mp="34x1vh8db93d" />
      <BlogSection data-id="element-14" data-mp="38kxclxdi5kq" />
      <FAQ data-id="element-15" data-mp="3uct2jhejuizf" />
      <ContactForm data-id="element-16" data-mp="3ud1dv4v0xg8i" />
      <Footer data-id="element-17" data-mp="3ubrfsfo6881v" />
    </div>;
}